function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

let lastScrollTop = 0;
const siteBody = document.querySelector('body');

function handleScroll() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      siteBody.classList.add('scrolled-down');
      siteBody.classList.remove('scrolled-up');
    } else if (scrollTop < lastScrollTop) {
      siteBody.classList.add('scrolled-up');
      siteBody.classList.remove('scrolled-down');
    }

    lastScrollTop = scrollTop;
  }
}

window.addEventListener("scroll", handleScroll);


function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => model.modelViewerUI?.pause());
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    //pdp page has multiple inputs for sticky header
    this.hasMultipleInputs = this.classList.contains("multiple-inputs")
    this.allInputs = document.querySelectorAll(".quantity__input")
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    //clicking on a button for one input updates all the others
    if (this.hasMultipleInputs) {
      for (let i = 0; i < this.allInputs.length; i++) {
        const input = this.allInputs[i];
        event.target.name === "plus" ? input.stepUp() : input.stepDown();
      }
    }
    else {
      event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('resize', (event)=>{
      if (window.innerWidth > 1290) {
        this.closeMenuDrawer(event, false, true)
      }
    })

    this.querySelectorAll("summary").forEach((summary) => {
      summary.addEventListener("click", this.onSummaryClick.bind(this));
    });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    // const root = document.getElementsByTagName( 'html' )[0];
    // root.classList.add("menu-open");
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement, false, false) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    // const root = document.getElementsByTagName( 'html' )[0];
    // root.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false, isFullMenu) {
    if (isFullMenu) {

      const root = document.getElementsByTagName('html')[0];
      root.classList.remove("menu-open");

      this.mainDetailsToggle.classList.remove("menu-opening");

      this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (document.querySelector(".compare-sizes__tab-list")) {
        document.querySelector(".compare-sizes__tab-list").style.zIndex = "5";
      }
    }

    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
  }

  onFocusOut(event) {
    //console.log(1)
    // setTimeout(() => {
    //   if (
    //     this.mainDetailsToggle.hasAttribute("open") &&
    //     !this.mainDetailsToggle.contains(document.activeElement)
    //   )
    //     this.closeMenuDrawer();
    // });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
    const root = document.getElementsByTagName('html')[0];
    const btnEl = event.currentTarget.closest("button");

    if (!btnEl.classList.contains('internal-menu')) {
      root.classList.remove("menu-open");
    }
  }

  closeSubmenu(detailsElement) {
    removeTrapFocus();
    this.closeAnimation(detailsElement);
    setTimeout(() => {
      detailsElement.classList.remove("menu-opening");
    }, 500);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}



class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }


  openMenuDrawer(summaryElement) {
    const root = document.getElementsByTagName( 'html' )[0];
    root.classList.add("menu-open");

    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      if (document.querySelector(".compare-sizes__tab-list")) {
        document.querySelector(".compare-sizes__tab-list").style.zIndex = "1";
      }
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}


// class ModalOpener extends HTMLElement {
//   constructor() {
//     super();

//     const button = this.querySelector("button");
//     button?.addEventListener("click", () => {
//       document.querySelector(this.getAttribute("data-modal"))?.show(button);
//     });
//   }
// }

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.images = document.querySelectorAll(".product__media-list .product__media img");
    this.modal = document.querySelector("product-modal .modal-image-wrapper");

    this.cleanModal();
    this.populateModal();
    this.setupButton();
  }

  // Remove all images from modal except the first one
  cleanModal() {
    this.modal?.querySelectorAll("img").forEach((image) => image.remove());

    document.querySelectorAll("product-modal .modal-image-wrapper").forEach((wrapper, index) => {
      if (index !== 0) wrapper.remove();
    });
  }

  // Add all images from product page to modal
  populateModal() {
    this.images.forEach((image) => {
      if (!this.modal?.querySelector(`[src="${image.src}"]`)) {
        const imageClone = image.cloneNode(true);
        this.modal.appendChild(imageClone);
      }
    });
  }

  // Opens modal and scrolls to the image that was clicked
  setupButton() {
    this.button?.addEventListener("click", () => {
      const mainImage = this.querySelector("img");
      let modalImage = this.modal.querySelector(`[src="${mainImage.src}"]`);

      if (!modalImage) {
        const mainImageSrcset = mainImage.getAttribute("srcset");
        const foundImage = Array.from(this.images).find((image) => image.getAttribute("srcset") === mainImageSrcset);
        modalImage = this.modal.querySelectorAll("img")[Array.from(this.images).indexOf(foundImage)];
      }

      modalImage?.scrollIntoView({ block: "center" });
      document.querySelector(this.getAttribute("data-modal"))?.show(this.button);
    });
  }
}


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector("video, model-viewer, iframe")).focus();
    }
  }
}


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const thumbnailsBox = document.querySelector('.product-thumbnails__slider');
    let slide = null
    let productBadge = document.querySelectorAll(".product__badge");
    let lastProductBadge = productBadge[productBadge.length - 1];
    let firstProductBadge = productBadge[0];
    let nextSlide = document.querySelector('.slider__slide.next')
    let previousSlide = document.querySelector( '.slider__slide.previous')
    if(event.target.hasAttribute('data-arrow-up')){
      slide = previousSlide
    } else if(event.target.hasAttribute('data-arrow-down')){
      slide = nextSlide
    }
    const slides = document.querySelectorAll('.slider__slide');
    slides.forEach(slide => slide.classList.remove('active', 'previous', 'next'))
    previousSlide = slide?.previousElementSibling
    previousSlide?.classList.add('previous')
    nextSlide = slide?.nextElementSibling
    nextSlide?.classList.add('next')
    slide?.classList.add('active')

    const thumbnailsBoxRect = thumbnailsBox.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();

    const relativeTop = slideRect.top - thumbnailsBoxRect.top;
    const relativeLeft = slideRect.left - thumbnailsBoxRect.left;
    thumbnailsBox.scrollTo({
      top: relativeTop,
      left: relativeLeft,
      behavior: "smooth",
    });
    if(!!nextSlide){
      document.querySelector('[data-arrow-down]')?.removeAttribute('disabled')
    } else {
      document.querySelector('[data-arrow-down]')?.setAttribute('disabled', '')
    }
    if(!!previousSlide){
      document.querySelector('[data-arrow-up]')?.removeAttribute('disabled')
    } else {
      document.querySelector('[data-arrow-up]')?.setAttribute('disabled', '')
    }

    let featuredImage = document.querySelector(".main-image-wrap img");
    let modalButton = document.querySelector(".main-image-wrap button");
    let slideButton = slide?.querySelector("button");
    let ismob = isMobile()
    let slideButtonModalId = slideButton.getAttribute("data-media-id");

    modalButton.setAttribute("data-media-id", slideButtonModalId);
    let slideImage = slide.querySelector(".product__media img");

    featuredImage["srcset"] = slideImage["srcset"];
    featuredImage.src = slideImage.src;

    if(ismob == false && lastProductBadge){
      if(!lastProductBadge) return;
      if(featuredImage.src.includes(originalFeaturedImageSrcParsed)) {
        lastProductBadge.style.display = "block";
      } else {
        lastProductBadge.style.display = "none";
      }
    } else {
      document.querySelectorAll('.product__badge').forEach((badge) => {
        if(!badge) return
        badge.style.display = "none";
        firstProductBadge.style.display = "block";
      });
    }
  }
}



class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback () {
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // const id = `price-${this.dataset.section}`;
        // const html = new DOMParser().parseFromString(responseText, 'text/html')
        // const destination = document.getElementById(id);
        // const source = html.getElementById(id);

        // if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.shopPayNeedsRender = false;
    this.previousVariant;
    this.stickyInfoBar = document.querySelector('.sticky-info-bar');
    this.stickyBarKlaviyoButton = this.stickyInfoBar?.querySelector('.notify-button');
    this.comingSoon = document.querySelector('.coming-soon');
    this.modalQuickView = this.closest('modal-quick-view-container');
  }

  connectedCallback(){
    // Hack-around Klaviyo onsitejs library, that doesn't allow to use multiple OOS buttons at the same page.
    this.stickyBarKlaviyoButton?.addEventListener('click', function (e){
      e.preventDefault()
      let klaviyoButton = document.querySelector('.notify-button.klaviyo-bis-trigger');
      klaviyoButton?.dispatchEvent(new Event('click', { bubbles: true }))
    })
  }

  onVariantChange() {
    console.log("hi")
    this.onOptionSelect();
    this.updateCurrentVariant();
    if (this.modalQuickView == null) {
      this.updateUrl();
      this.updateImages();
    } else {
      this.modalQuickView.dispatchEvent(new CustomEvent("variant-changed", {
        detail: this.currentVariant
      }))
    }
    this.updateSoldOutBadge();
    this.updatePrice();
    this.updateForm();
    this.updateTitle();
    this.updateShopPayWidget();
    this.setMonogramHref();
    this.setPatchesHref()
  }

  setMonogramHref() {
    const monogramLink = document.querySelector("#monogram-link");
    if (!monogramLink) return;
    monogramLink.href = `/products/${this.currentVariant.dataset.handle}?variant=${this.currentVariant.dataset.id}&view=monogram`;
  }

  setPatchesHref() {
    const patchLink = document.querySelector('.new-customize-button');
    if(!patchLink) return;
    patchLink.href = `/products/${this.currentVariant.dataset.handle}?view=customizer&variant=${this.currentVariant.dataset.id}`;
  }

  async updateShopPayWidget() {
    const currentShopPayWidgets = document.querySelectorAll('shopify-payment-terms');
    const handle = this.currentVariant.dataset.handle;
    const parser = new DOMParser();

    if (!handle) return;

    if (this.previousVariant && this.previousVariant.dataset.seasonal
      || this.currentVariant.dataset.seasonal) {
      this.shopPayNeedsRender = true;
    } else {
      this.shopPayNeedsRender = false;
    }

    if (!this.shopPayNeedsRender) return;

    currentShopPayWidgets.forEach((widget) => widget.style.opacity = 0);
    const productPage = await (await fetch(`/products/${handle}`)).text();
    const doc = parser.parseFromString(productPage, 'text/html');
    const newShopPayWidget = doc.querySelector('shopify-payment-terms');
    const variantId = newShopPayWidget.getAttribute('variant-id');
    const shopifyMeta = newShopPayWidget.getAttribute('shopify-meta');

    currentShopPayWidgets.forEach((widget) => {
      widget.setAttribute('variant-id', variantId);
      widget.setAttribute('shopify-meta', shopifyMeta);
      widget.style.opacity = 1;
    });
  }

  updateTitle() {
    const productTitle = document.querySelectorAll('.product__title');
    this.productTitle = JSON.parse(
      document.querySelector('.product__media-wrapper [type="application/json"]').innerHTML
    )?.find((variant) => variant.id === this.currentVariant.dataset.id)?.productTitle;

    productTitle.forEach((title) => title.innerText = this.productTitle);
  }

  updatePrice() {
    const priceTexts = document.querySelectorAll('.price-item.price-item--regular');
    const priceSalesTexts = document.querySelectorAll('.price-item.price-item--sale');
    const shopPay = document.querySelector('shopify-payment-terms');
    const currentVariant = JSON.parse(
      document.querySelector('.product__media-wrapper [type="application/json"]').innerHTML
    )?.find((variant) => variant.id === this.currentVariant.dataset.id);

    // Fix lemon promotion
    this.variantPrice = currentVariant?.price;
    let variantSalePrice = currentVariant?.compare_at_price;

    // Update price texts and update Shop Pay widget
    if (variantSalePrice && variantSalePrice.replace(/[$,USD,\s]+/g,"") !== '0.00') {
      priceTexts.forEach((price) => price.innerText = variantSalePrice);
      priceSalesTexts.forEach((price) => {
        price.innerText = this.variantPrice;
        if (price.closest('.price')) {
          price.closest('.price').classList.add('price--on-sale');
        }
      });
    } else {
      priceTexts.forEach((price) => {
        price.innerText = this.variantPrice;
        if (price.closest('.price')) {
          price.closest('.price').classList.remove('price--on-sale');
        }
      });
    }

    if(shopPay) {
      shopPay.setAttribute('variant-id', this.currentVariant.dataset.id);
    }
  }

  updateCurrentVariant() {
    this.previousVariant = this.currentVariant;
    const inputs = document.querySelectorAll('[data-type="add-to-cart-form"] [name="id"]');
    this.currentVariant = this.querySelector("input:checked");
    inputs.forEach((input) => (input.value = this.currentVariant.dataset.id));
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }

  updateUrl() {
    if (this.currentVariant.dataset.seasonal) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.dataset.id}`
    );
  }

  onOptionSelect() {
    this.selectedOption = this.querySelector("input:checked");
    const value = this.selectedOption.value
    const wrapper = document.querySelector('legend.form__label.optionName .selectedValue');
    wrapper.innerHTML = value;
  }

  updateImages() {
    if (document.querySelector('.product__media-wrapper [type="application/json"]') != null) {
      this.variantImages = JSON.parse(
        document.querySelector('.product__media-wrapper [type="application/json"]')?.innerHTML
      )?.find((variant) => variant.id === this.currentVariant.dataset.id)?.media;
    }

    if (this.variantImages.length) {
      this.currentImagesNodes = document.querySelectorAll("[data-metafield-media]");
      this.currentImagesNodes.forEach((img) => img.remove());
      this.slider = document.querySelector("slider-component ul");

      this.variantImages.forEach((img, index) =>
        this.slider.insertAdjacentHTML("afterbegin", this.renderImage(img, index))
      );
      setTimeout(() => {
        document.querySelectorAll("[data-metafield-media]").forEach((img) =>
          img.classList.remove("loading")
        );
      }, 100)

    }
    //letters and numbers
    else {
      const allVariants = this.getVariantData();
      const currentId = parseInt(this.currentVariant.dataset.id)
      const variantData = allVariants.find(variant => currentId===variant.id)

      if (!variantData || !variantData?.featured_media) return;
      const thumbnail = document.querySelector(
        `[data-media-id="${variantData.featured_media.id}"]`
      );
      if (!thumbnail) return;
      const listItem = thumbnail.parentElement.parentElement;
      const letterFeaturedImage = this.currentVariant.dataset.image
      const mainImage = document.querySelector(".main-image-wrap img");

      if (window.innerWidth < 750) {
        listItem.parentNode.scrollLeft = listItem.offsetLeft
      }
      else {
        mainImage.removeAttribute("srcset")
        mainImage.src = letterFeaturedImage;
      }
    }
  }

  updateSoldOutBadge() {
    this.available = this.selectedOption.dataset.available;
    this.comingSoonBadge = this.selectedOption.dataset.isComingSoon;
    const productBadges = document.querySelectorAll('.product__badge-wrapper')
    if (this.available === 'false') {
        productBadges.forEach(badge => {
        badge.innerHTML = this.renderSoldOutBadge()
      })
    } else if (this.comingSoonBadge === 'true') {
        productBadges.forEach(badge => {
        badge.innerHTML = this.renderComingSoonBadge();
       });
    }
      else {
        productBadges.forEach(badge => {
        badge.innerHTML = this.renderBadge()
      })
    }
  }

  updateForm() {
    this.productInfoContainer = document.querySelector('.product__info-container');
    this.submitButtons = document.querySelectorAll('.product-form__submit');
    this.qtySelectors = document.querySelectorAll('.product-form__quantity');
    this.klaviyoButton = document.querySelector('.notify-button.klaviyo-bis-trigger');
    const selectedVariant = this.getVariantData().find(variant => variant.id === +this.currentVariant?.dataset.id)

    this.productInfoContainer.querySelector('.js-preorder-message').classList.add('hidden')
    this.productInfoContainer.querySelector('.js-preorder-message').innerHTML = selectedVariant.preorder_message
    this.productInfoContainer.querySelector('.js-preorder-property-message').value = selectedVariant.preorder_message
    this.productInfoContainer.querySelector('.js-preorder-property-value').removeAttribute('name')
    this.productInfoContainer.querySelector('.js-preorder-property-message').removeAttribute('name')
    if (this.klaviyoButton) {
      this.klaviyoButton.style.opacity = '0';
      this.klaviyoButton.style.height = '0';
    }
    if (this.available === 'false') {
      this.productInfoContainer?.classList.add('product__info-container--sold-out');
      this.stickyInfoBar?.classList.add('sticky-info-bar--sold-out');
      this.submitButtons.forEach(btn => {
        btn.classList.add('sold-out')
        btn.disabled = true
        const btnText = btn.querySelector('span')
        btnText.innerHTML = 'Sold out'
      })
      this.qtySelectors.forEach(qty => qty.classList.add('sold-out'))
      if (this.klaviyoButton) {
        this.klaviyoButton.style.opacity = '1';
        this.klaviyoButton.style.removeProperty('height');
      }
        this.submitButtons.forEach(btn => {
        const isComingSoon = this.selectedOption.dataset.isComingSoon === 'true';
        if (isComingSoon && this.comingSoon) {
          btn.disabled = true;
          this.comingSoon.style.display = 'block';
        } else if (this.comingSoon) {
          this.comingSoon.style.display = 'none';
        }
      });
    } else {
      this.productInfoContainer?.classList.remove('product__info-container--sold-out');
      this.stickyInfoBar?.classList.remove('sticky-info-bar--sold-out');
      this.submitButtons.forEach(btn => {
        btn.classList.remove('sold-out');
        btn.disabled = false
        const btnText = btn.querySelector('span')
        const isComingSoon = this.selectedOption.dataset.isComingSoon === 'true';
        if (isComingSoon && this.comingSoon) {
          btn.disabled = true;
          this.comingSoon.style.display = 'block';
        } else if (this.comingSoon) {
          this.comingSoon.style.display = 'none';
        }

        if (selectedVariant.available && selectedVariant.inventory_quantity <= selectedVariant.inventory_threshold) {
          btnText.innerHTML = 'Pre order'
          this.productInfoContainer.querySelector('.js-preorder-message').classList.remove('hidden')
          this.productInfoContainer.querySelector('.js-preorder-property-value').setAttribute('name', 'properties[Pre-order]')
          this.productInfoContainer.querySelector('.js-preorder-property-message').setAttribute('name', 'properties[preorder_message]')
        } else {
          if (this.modalQuickView != null) {
            const price = this.variantPrice ? ` • ${this.variantPrice.split(' ')[0]}` : '';
            btnText.innerHTML = isComingSoon ? 'Coming soon' : `Add to bag${price}`;
          } else {
            btnText.innerHTML = isComingSoon ? 'Coming soon' : `Add to bag`;
          }
        }
      })
      this.qtySelectors.forEach(qty => qty.classList.remove('sold-out'))
    }
  }

  renderSoldOutBadge() {
    return `<img class="product__badge" src="https://cdn.shopify.com/s/files/1/0096/2392/files/Sold_Out_3.png?v=1692117439" alt="Sold Out">`;
  }

  renderComingSoonBadge() {
    return `<img class="product__badge" src="https://cdn.shopify.com/s/files/1/0096/2392/files/Coming_Soon_1.png?v=1692110999" alt="Coming Soon">`;
  }

  renderBadge() {
    this.badge = this.selectedOption.dataset.badge;
    return this.badge ? `<img class="product__badge" src="${this.badge}">` : ''
  }
  renderImage(src, index) {
    return `<li data-metafield-media class="loading product__media-item grid__item slider__slide  " data-media-id="${this.dataset.section}-${this.currentVariant.dataset.id}-${index}">
    <modal-opener class="product__modal-opener product__modal-opener--image  no-js-hidden">
      <span class="product__media-icon motion-reduce" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-plus">
      <circle cx="20" cy="20" r="20" fill="white"></circle>
      <line x1="21" y1="13" x2="21" y2="28" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round"></line>
      <line x1="28" y1="21" x2="13" y2="21" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round"></line>
    </svg></span>
    
      <div class="product__media media media--transparent" style="padding-top: 100%;">
        <img src="${src}" sizes="(min-width: 1600px) 960px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="576" alt="">
      </div>
      <button class="product__media-toggle" type="button" aria-haspopup="dialog" data-media-id="">
        <span class="visually-hidden">Open media 2 in gallery view
    </span>
      </button>
    </modal-opener>
                </li>`;
  }
  getVariantData() {
    const jsonElement = this.querySelector('[type="application/json"]');
    if (!jsonElement) {
        console.error("JSON element not found!");
        return null;
    }
    this.variantData = this.variantData || JSON.parse(jsonElement.textContent);
    return this.variantData;
  }
}

class VariantRadiosTigerEloise extends HTMLElement {
  constructor() {
    super();
    this.urlParams = new URLSearchParams(window.location.search);
    this.selectedOptions = []
    this.stickyInfoBar = document.querySelector('.sticky-info-bar');
    this.stickyBarKlaviyoButton = this.stickyInfoBar?.querySelector('.notify-button');
    this.comingSoon = document.querySelector('.coming-soon');
  }
  updateMedia() {
    if (!this.selectedVariant || !this.selectedVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.selectedVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }
  renderProductInfo() {
    const priceSelector = '.pricebox'
    const shopPayWidgetSelector = 'shopify-payment-terms'

    const renderElements = (sourceHTML, selectors = []) => {
      if (sourceHTML && selectors) {
        for (let selector of selectors) {
          document.querySelector(selector).innerHTML = sourceHTML.querySelector(selector).innerHTML;
        }
      }
    }

    const updateShopPayWidget = (sourceHTML) => {
      const shopPayWidgets = document.querySelectorAll(shopPayWidgetSelector);
      if (shopPayWidgets){
        shopPayWidgets.forEach((widget) => widget.style.opacity = 0);
        const newShopPayWidget = sourceHTML.querySelector(shopPayWidgetSelector);
        if(newShopPayWidget){
          const variantId = newShopPayWidget.getAttribute('variant-id');
          const shopifyMeta = newShopPayWidget.getAttribute('shopify-meta');

          shopPayWidgets.forEach((widget) => {
            widget.setAttribute('variant-id', variantId);
            widget.setAttribute('shopify-meta', shopifyMeta);
            widget.style.opacity = 1;
          });
        }
      }
    }
    fetch(
      `${this.dataset.url}?view=tiger-eloise&variant=${this.selectedVariant.id}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        renderElements(html, [priceSelector])
        updateShopPayWidget(html)
      });
  }
  renderImage(src, index) {
    return `<li data-metafield-media class="loading product__media-item grid__item slider__slide" data-media-id="${this.dataset.section}-${this.selectedVariant.id}-${index}">
    <modal-opener class="product__modal-opener product__media-item product__modal-opener--image  no-js-hidden">
      <span class="product__media-icon motion-reduce" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-plus">
      <circle cx="20" cy="20" r="20" fill="white"></circle>
      <line x1="21" y1="13" x2="21" y2="28" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round"></line>
      <line x1="28" y1="21" x2="13" y2="21" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round"></line>
    </svg></span>
    
      <div class="product__media media media--transparent" style="padding-top: 100%;">
        <img src="${src}" sizes="(min-width: 1600px) 960px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="576" alt="">
      </div>
      <button class="product__media-toggle" type="button" aria-haspopup="dialog" data-media-id="">
        <span class="visually-hidden">Open media 2 in gallery view
    </span>
      </button>
    </modal-opener>
                </li>`;
  }
  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[data-variants-json][type="application/json"]').textContent);
    return this.variantData;
  }

  getComingSoonVariants() {
    if(!this.querySelector('[data-coming-soon-variants][type="application/json"]')) {
      return [];
    }
    return JSON.parse(this.querySelector('[data-coming-soon-variants][type="application/json"]').textContent);
  }

  renderSoldOutSwatches() {
    const swatches = document.querySelectorAll('.product__info-wrapper .swatch');
    const letters = document.querySelectorAll('.product__info-wrapper input[name="Size"]');
    const option = this.selectedVariant.option2;

    swatches.forEach(swatch => {
      const swatchValue = swatch.querySelector('input').value;
      const variantsWithOption = this.productJSON.variants.filter(variant => variant.option2 === swatchValue);
      // check if all variantsWithOption are unavailable
      const allVariantsUnavailable = variantsWithOption.every(variant => variant.available === false);
      if (allVariantsUnavailable) {
        swatch.classList.add('unavailable');
      } else {
        swatch.classList.remove('unavailable');
      }
    });

    const variantsWithOption = this.productJSON.variants.filter(variant => variant.option2 === option);
    variantsWithOption.forEach(variant => {
      const letter = Array.from(letters).find(letter => letter.value === variant.option1);
      if (!variant.available && letter) {
        letter.classList.add('unavailable');
        letter.setAttribute('alt', `Sold out - ${letter.value}`);
        letter.setAttribute('aria-label', `Sold out - ${letter.value}`);

        const label = letter.nextElementSibling;
        if (label) {
          label.setAttribute('aria-label', `Sold out - ${letter.value}`);
        }
      } else {
        letter.classList.remove('unavailable');
        letter.setAttribute('alt', letter.value);
        letter.setAttribute('aria-label', letter.value);

        const label = letter.nextElementSibling;
        if (label) {
          label.setAttribute('aria-label', letter.value);
        }
      }
    });
  }
  setMonogramHref() {
    const monogramLink = document.querySelector("#monogram-link");
    if (!monogramLink) return;
    monogramLink.href = `${this.dataset.url}?variant=${this.selectedVariant.id}&view=monogram`;
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
  updateCurrentVariant() {
    const inputs = document.querySelectorAll('[data-type="add-to-cart-form"] [name="id"]');
    inputs.forEach((input) => (input.value = this.selectedVariant.id));
  }
  updateImages() {
    this.variantImages = JSON.parse(
      document.querySelector('.product__media-wrapper [type="application/json"]')?.innerHTML
    )?.find((variant) => Number(variant.id) === Number(this.selectedVariant.id))?.media;

    this.currentImagesNodes = document.querySelectorAll("[data-metafield-media]");
    this.currentImagesNodes.forEach((img) => img.remove());
    if (this.variantImages.length) {
      this.slider = document.querySelector("slider-component ul");
      this.variantImages.forEach((img, index) =>
        this.slider.insertAdjacentHTML("afterbegin", this.renderImage(img, index))
      );
      setTimeout(() => {
        document.querySelectorAll("[data-metafield-media]").forEach((img) =>
          img.classList.remove("loading")
        );
      }, 100)
    }
    //letters and numbers
    else {
      const allVariants = this.getVariantData();
      const currentId = parseInt(this.selectedVariant.id)
      const variantData = allVariants.find(variant => currentId===variant.id)
      if (!variantData || !variantData?.featured_media) return;
      const thumbnail = document.querySelector(
        `[data-media-id="${variantData.featured_media.id}"]`
      );
      if (!thumbnail) return;
      const listItem = thumbnail.parentElement.parentElement;
      const letterFeaturedImage = this.selectedVariant.featured_image
      const mainImage = document.querySelector(".main-image-wrap img");
    }

    const firstImage = document.querySelector('.product__media-item img')
    const mainImage = document.querySelector('.main-image-wrap .media img')
    document.querySelectorAll('li.product__media-item').forEach(item => item.classList.remove('active'))
    document.querySelector('.product__media-item').classList.add('active')
    if(firstImage.src.includes('no-image')){
      const srcset = firstImage.getAttribute('srcset').split(', ')
      firstImage.src = srcset[srcset.length - 1].split(' ')[0]
    }
    mainImage.src = firstImage.src
  }
  updateForm() {
    const productInfoContainer = document.querySelector('.product__info-container');
    const submitButtons = document.querySelectorAll('.product-form__submit');
    const qtySelectors = document.querySelectorAll('.product-form__quantity');
    const klaviyoButton = document.querySelector('.notify-button.klaviyo-bis-trigger');
    const comingSoon = document.querySelector('.coming-soon');

    if (klaviyoButton) {
      klaviyoButton.style.opacity = '0';
      klaviyoButton.style.height = '0';
    }
    if (this.selectedVariant.available === false) {
      productInfoContainer?.classList.add('product__info-container--sold-out');
      this.stickyInfoBar?.classList.add('sticky-info-bar--sold-out');
      submitButtons.forEach(btn => {
        btn.classList.add('sold-out')
        btn.disabled = true
        const btnText = btn.querySelector('span')
        btnText.innerHTML = 'Sold out'
      })
      qtySelectors.forEach(qty => qty.classList.add('sold-out'))
      if (klaviyoButton) {
        klaviyoButton.style.opacity = '1';
        klaviyoButton.style.removeProperty('height');
      }

    } else {
      productInfoContainer?.classList.remove('product__info-container--sold-out');
      this.stickyInfoBar?.classList.remove('sticky-info-bar--sold-out');
      submitButtons.forEach(btn => {
        btn.classList.remove('sold-out');
        btn.disabled = false
        const btnText = btn.querySelector('span')
        const isComingSoon = this.getComingSoonVariants().includes(this.selectedVariant.id);
        btnText.innerHTML = isComingSoon ? 'Coming soon' : 'Add to bag';
        if (isComingSoon && comingSoon) {
          btn.disabled = true;
          comingSoon.style.display = 'block';

        } else if (comingSoon) {
          comingSoon.style.display = 'none';

        }

      })
      qtySelectors.forEach(qty => qty.classList.remove('sold-out'))
    }
  }
  updateBadge() {
    const productBadges = document.querySelectorAll('.product__badge-wrapper');
    if (this.selectedVariant?.product_badge) {
      productBadges.forEach(badge => {
        badge.innerHTML = this.renderBadgeHTML();
      })
    } else {
      productBadges.forEach(badge => {
        badge.innerHTML = '';
      })
    }
  }
  renderBadgeHTML() {
    this.badge = this.selectedVariant.product_badge;
    return this.badge ? `<img class="product__badge" src="${this.badge}">` : ''
  }
  updateFormIdInputs(){
    const variantId = this.selectedVariant.id
    document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(inputEl => inputEl.value = variantId)
  }


  onVariantChange(){
    this.updateOptions();
    this.onOptionSelect();
    this.updateFormIdInputs()
    this.updateUrl()
    this.renderProductInfo()
    this.updateForm()
    this.updateBadge()
    this.updateImages()
    this.updateMedia()
    this.renderSoldOutSwatches()
    this.setMonogramHref()
    // this.changeMeasurementsDetails()
  }

  // changeMeasurementsDetails() {
  //   const measuresementsImage = document.querySelector('#measurements-image');
  //   const measurementsContainer = document.querySelector('#measurements-container');
  //   measurementsContainer.style.display = 'block';
  //   if (this.selectedVariant.measurements) {
  //     measuresementsImage.src = this.selectedVariant.measurements;
  //     return;
  //   }
  // }

  getProductData(){
    this.productJSON = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  }
  changeQueryString(searchString, documentTitle){
    documentTitle = typeof documentTitle !== 'undefined' ? documentTitle : document.title;
    let urlSplit=( window.location.href ).split( "?" );
    let obj = { Title: documentTitle, Url: urlSplit[0] + searchString };
    history.pushState(obj, obj.Title, obj.Url);
  }
  onOptionInputChange(){
    document.querySelectorAll('input[data-option-input]:checked').forEach(input=> {
      this.selectedOptions[Number(input.dataset.optionInput)] = input.value;
    })
    this.previousVariant = this.selectedVariant
    this.selectedVariant = this.productJSON.variants.find(variant => this.selectedOptions.every((op, index) => op === variant[`option${index + 1}`]))
    this.onVariantChange()

  }
  updateUrl(){
    this.urlParams.set('variant', this.selectedVariant.id)
    this.changeQueryString('?' + this.urlParams.toString())
  }

  updateTitle() {
    const productTitle = document.querySelectorAll('.product__title');
    this.productTitle = JSON.parse(
      document.querySelector('.product__media-wrapper [type="application/json"]').innerHTML
    )?.find((variant) => variant.id === this.currentVariant.dataset.id)?.productTitle;

    productTitle.forEach((title) => title.innerText = this.productTitle);
  }

  onOptionSelect() {
    this.productJSON = this.productJSON || JSON.parse(this.querySelector('[data-product-json]').innerHTML);
    if(!this.productJSON.options) return;

    this.productOptions = this.productJSON.options;

    this.querySelectorAll('legend.form__label.optionName').forEach(wrapper => {
        const position = Object.keys(this.productOptions).findIndex(option => option.toLowerCase() === wrapper.dataset.option.toLowerCase());

        if(position !== -1) {
          const value = this.selectedVariant[`option${position + 1}`]
          wrapper.querySelector('.selectedValue').innerHTML = value;
        }
    })
  }

  connectedCallback() {
    this.getProductData()
    document.querySelectorAll('input[data-option-input]').forEach(el => el.addEventListener("change", this.onOptionInputChange.bind(this)))
    this.selectedVariant = this.productJSON.variants.find(v => v.id.toString() === this.urlParams.get('variant')) || this.productJSON.variants.find(v => v.available === true) || this.productJSON.variants[0]
    this.selectedOptions = this.selectedVariant.options
    this.updateUrl()
    this.renderSoldOutSwatches();

    this.stickyBarKlaviyoButton?.addEventListener('click', function (e){
      e.preventDefault()
      let klaviyoButton = document.querySelector('.notify-button.klaviyo-bis-trigger');
      klaviyoButton?.dispatchEvent(new Event('click', { bubbles: true }))
    })
  }
}
class Bullets extends HTMLElement {
  constructor() {
    super();
    this.ulObserver = new MutationObserver(() => this.updateBullets());
  }

  connectedCallback() {
    const sliderComponent = this.closest('slider-component');
    const ul = sliderComponent.querySelector('ul.product-thumbnails__slider');
    this.ulObserver.observe(ul, {
      childList: true,
    });
    this.updateBullets();
  }

  updateBullets() {
    const sliderComponent = this.closest('slider-component');
    const ul = sliderComponent.querySelector('ul.product-thumbnails__slider');
    this.innerHTML = ''; // Clear existing bullets

    ul.querySelectorAll('li').forEach((li) => {
      const span = document.createElement('span');
      if (li.classList.contains('active')) {
        span.classList.add('active');
      }

      span.addEventListener('click', () => this.handleClick(span));
      this.appendChild(span);
    });

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => this.handleIntersect(entries), options);
    ul.querySelectorAll('li').forEach((li) => observer.observe(li));
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.querySelectorAll('span').forEach(span => {
          span.classList.remove('active');
        });

        const liIndex = Array.from(this.closest('slider-component').querySelectorAll('ul.product-thumbnails__slider li')).indexOf(entry.target);
        this.querySelectorAll('span')[liIndex].classList.add('active');
      }
    });
  }

  handleClick(clickedSpan) {
    const allSpans = Array.from(this.querySelectorAll('span'));
    const spanIndex = allSpans.indexOf(clickedSpan);
    const correspondingLi = this.closest('slider-component').querySelectorAll('ul.product-thumbnails__slider li')[spanIndex];

    // Scroll the ul element to make the corresponding li visible
    correspondingLi.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
  }
}

class ColorSwatches extends  HTMLElement {
  constructor() {
    super();
  }
  

  connectedCallback() {
    this.toggler = this.querySelector('[data-swatch-toggle]');
    this.card = this.closest("[data-product-card-wrapper]");
    this.imagesWrapper = this.card?.querySelector("[data-product-card-images]");
    this.swatches = Array.from(this.querySelectorAll('.swatch'));
    this.productAnchors = Array.from(this.card?.querySelectorAll('[data-product-card-url]') || []);
    
    if(this.toggler) {
      this.toggler.addEventListener('click', this.toggleSwatches.bind(this));
    }

    this.addEventListener("click", this.handleSwatchClick.bind(this))
    this.slideToInitialImage();
  }

  slideToInitialImage() {
    const activeSwatch = this.swatches.find(swatch => swatch.classList.contains("active"));

    this.slideToActiveImage(activeSwatch.dataset.variantId)
  }

  handleSwatchClick(evt) {
    const swatch = evt.target.closest(".swatch");

    if(!swatch) return;

    this.swatches.forEach(sw => sw.classList.remove("active"))
    swatch.classList.add("active")
    this.slideToActiveImage(swatch.dataset.variantId)

    const variantUrl = swatch.dataset.variantUrl;
    if(variantUrl) {
      this.productAnchors.forEach(anchor => anchor.href = variantUrl)
    }
  }

  slideToActiveImage(id) {
    if(!id) return;
    if(!this.imagesWrapper) return;
		const targetImg = this.imagesWrapper.querySelector(`img[data-variants*="${id}"]`)
    if(!targetImg) return;

		const offsetLeft = targetImg.offsetLeft - this.imagesWrapper.offsetLeft;
		this.imagesWrapper.scrollTo({ left: offsetLeft, behavior: "smooth" })
	}

  toggleSwatches() {
    this.openButton = this.querySelector('.plus');
    this.closeButton = this.querySelector('.minus');

    this.openButton.classList.toggle('hidden');
    this.closeButton.classList.toggle('hidden');

    this.swatches.forEach(swatch => {
      if (swatch.dataset.hiddenSwatch == 'true') {
        swatch.classList.toggle('hidden');
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("loading shopify custom elements")
  customElements.define("quantity-input", QuantityInput);
  customElements.define("menu-drawer", MenuDrawer);
  customElements.define("header-drawer", HeaderDrawer);
  customElements.define("modal-dialog", ModalDialog);
  customElements.define("variant-radios", VariantRadios);
  customElements.define("variant-radios-te", VariantRadiosTigerEloise);
  customElements.define("deferred-media", DeferredMedia);
  customElements.define("modal-opener", ModalOpener);
  customElements.define("slider-component", SliderComponent);
  customElements.define("variant-selects", VariantSelects);
  customElements.define('bullets-element', Bullets);
  customElements.define('color-swatches', ColorSwatches);
});
